module.exports = __webpack_public_path__ + "img/frame-992.90b1e5aa.png";